module.exports = __webpack_public_path__ + "img/kg.b7f9b2a5.svg";